import React from 'react'

export const TitleSection = ({ title, description }) => {
  return (
    <div className="section-title">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
}
